<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="mb-3">
        <vs-input :label="$t('label')" :placeholder="$t('label')" v-model="formData.label" class="w-full"/>
        <validation-error :model-error="formDataErrors.label"></validation-error>
      </div>
    </div>

  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import Queue from '@/models/Queue'

export default {
  name: 'Shared.Queue.Label.Edit',
  data () {
    return {
      formData: {
        id: '',
        label: ''
      },
      formDataErrors: []
    }
  },
  mounted () {
    EventBus.$on('initEditQueueStatusLabel', this.initEditQueueStatusLabel)
    EventBus.$on('initUpdateQueueStatusLabel', this.initUpdateQueueStatusLabel)
  },
  methods: {
    async initEditQueueStatusLabel (queueId) {
      this.$vs.loading({container: '#EditQueueLabelFormContainer'})
      try {
        const response = await Queue.view({ id: queueId })
        this.formData = response.data.queue
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
      this.$vs.loading.close('#EditQueueLabelFormContainer > .con-vs-loading')
    },
    async initUpdateQueueStatusLabel () {

      this.$vs.loading({background: 'primary', color: '#fff', container: '#updateQueueStatusLabelButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          const response = await Queue.updateLabel(this.formData)

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$emit('updateSuccess')
        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.formDataErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#updateQueueStatusLabelButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
#updateQueueStatusLabelButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
